module.exports = __webpack_public_path__ + "img/promo-header-logo.daa1a134.jpg";